import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import InputSequenceComponent from '../components/InputSequenceComponent';
import IAppState from '../../../IAppState';
import {IInputSequenceComponentPropsData, IInputSequenceComponentPropsFunctions} from '../props/IInputSequenceComponentProps';
import ActMain from "../../../act-main";
import ActSummary from "../../SummaryPage/state/act-summary";
import {clientUrlPrefix} from '../../../settings';
import IDT from "../interfaces/InputDataType";
import { ll_fetch } from '../../../tools';
import ATE from '../../../ActionTypeEnum';

function submitInput(dispatch: any, browserHistory: any) {
    dispatch(ActSummary.submitInput());

    browserHistory.push(clientUrlPrefix+"/job-settings");
}


interface IOwnProps {
    ecNumber?: string,choice
    customQuery?: boolean,
    history: any,
}

async function sequenceFromID(dispatch: any, uniprotId: string) {
    dispatch(ActMain.changeUniprotIdField(uniprotId));

    await ll_fetch(`/api/uniprot/getSequence?uniprotId=${uniprotId}`)
    .then(response => {
        if (response.ok) {
            response.text().then(data => { 
                console.log(data);
                dispatch(ActMain.changesequence(data));

                dispatch({
                    type: ATE.SET_SEQUENCE_CHECKED,
                    value: true
                });

            });
        } else {
            console.log("error");
            alert("We were unable to obtain sequence from database. Please check your UniProt ID.");
            return false;
        }
    })
    .catch(err => {
        alert("We were unable to obtain sequence from database. Please check your UniProt ID.");
        console.log("FAILED")
        console.error(err);
        return false;
    })
    return true;
}

function checkSequence(dispatch: any, sequence: string){

    dispatch({
        type: ATE.SET_SEQUENCE_CHECKED,
        value: false
    });

    const allowed = ["A", "a", "R", "r", "N", "n", "D", "d", "C", "c", "Q", "q", "E", "e", "G", "g", "H", "h", "I", "i", "L", "l", "K"
    , "k", "M", "m", "F", "f", "P", "p", "S", "s", "T", "t", "W", "w", "Y", "y", "V", "v"];

    var isOK = true;
    for(var i = 0; i < sequence.length; i++){
        if(!allowed.includes(sequence.charAt(i))){
            isOK = false;
            alert("We have detected some non-standard characters in the amino acid sequence: " + sequence.charAt(i));
            break;
        }
    }
    if(isOK){
        dispatch({
            type: ATE.SET_SEQUENCE_CHECKED,
            value: true
        });
    }
}

const mapStateToProps = ({mainState}: IAppState, ownProps: IOwnProps): IInputSequenceComponentPropsData => {
    return {
        sequence: mainState.sequence,
        uniprotIdField: mainState.uniprotIdField,
        modelling: mainState.modelling,
        sequenceChecked: mainState.sequenceChecked,
    }
};

const mapDispatchToProps = (dispatch: any, ownProps: IOwnProps): IInputSequenceComponentPropsFunctions => ({
    changesequence : (sequence: string ) => dispatch(ActMain.changesequence(sequence)),
    sequenceFromID: (uniprotId: string) => sequenceFromID(dispatch, uniprotId),
    toggleModelling : () => dispatch(ActMain.toggleModelling()),
    changeUniprotIdField : (uniprotIdField: string ) => dispatch(ActMain.changeUniprotIdField(uniprotIdField)),
    submitInput: () => submitInput(dispatch, ownProps.history),
    checkSequence: (sequence: string) => checkSequence(dispatch, sequence),
})


const InpuSequencetContainer = withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(InputSequenceComponent));

export default InpuSequencetContainer;
